import ParentProducerAgency from './ParentProducerAgency';
import ProducerAgent from './ProducerAgent';
import ProducerAgency from './ProducerAgency';

export default class ProducerInfo {
	public producerAgent: ProducerAgent | null = null;
	public producerAgency: ProducerAgency | null = null;
	public parentProducerAgency: ParentProducerAgency | null = null;

	public constructor() {

	}
};